import { render, staticRenderFns } from "./questionMstManage.vue?vue&type=template&id=d298d02a"
import script from "./questionMstManage.vue?vue&type=script&lang=js"
export * from "./questionMstManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d298d02a')) {
      api.createRecord('d298d02a', component.options)
    } else {
      api.reload('d298d02a', component.options)
    }
    module.hot.accept("./questionMstManage.vue?vue&type=template&id=d298d02a", function () {
      api.rerender('d298d02a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/quiz/questionMstManage.vue"
export default component.exports